<template>
  <div class="container">
    <nav class="add-navigation flex-wrap">
      <div @click="$emit('close')" class="back-link my-1">
        <svg class="icon" width="30px" height="30px" viewBox="0 0 30 30" version="1.1">
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          />
        </svg>
        <p>Back to Vendors</p>
      </div>
      <div class="buttons-wrapper my-1">
        <div @click="$emit('close')" class="secondary-button">
          <secondary-button>Cancel</secondary-button>
        </div>
        <div class="primary-button">
          <primary-button @click.native="addDid">Add DID</primary-button>
        </div>
      </div>
    </nav>
    <div class="add-container">
      <span class="container-title">Add DID</span>
      <div class="col-wrapper">
        <div class="col">
          <!-- <loader :loading="loading" v-if="loading" class="loading" /> -->
          <!-- <primary-select
            type="text"
            name="did"
            class="type"
            v-model="did"
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('did')}"
            placeholder="DID"
            :options="dids"
          />
          <div class="help is-danger" v-if="errors.has('did')">{{ errors.first('did') }}</div>-->
          <div class="field">
            <primary-input
              name="did"
              v-model="newDid.did"
              :class="{'input': true, 'is-danger': errors.has('did')}"
              v-validate="'required'"
            />
            <div class="help is-danger" v-if="errors.has('did')">{{ errors.first('did') }}</div>
          </div>
          <div class="field">
            <primary-select
              type="text"
              name="did type"
              class="type"
              v-model="newDid.did_type"
              v-validate="'required'"
              :class="{'input': true, 'is-danger': errors.has('did_type')}"
              placeholder="Type"
              :options="did_type"
            />
            <div class="help is-danger" v-if="errors.has('did')">{{ errors.first('did') }}</div>
          </div>
          <div class="field">
            <primary-select
              type="text"
              name="country"
              class="type"
              v-model="newDid.country_uuid"
              v-validate="'required'"
              :class="{'input': true, 'is-danger': errors.has('country_uuid')}"
              placeholder="Type"
              :options="countries"
            />
            <div
              class="help is-danger"
              v-if="errors.has('country_uuid')"
            >{{ errors.first('country_uuid') }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    Loader: () => import("@/components/Loader.vue"),
  },
  props: ["vendorId"],
  data: () => ({
    statusTypes: [
      { name: "Active", value: true },
      { name: "InActive", value: false },
    ],
    newDid: {
      did: null,
      vendor_uuid: null,
      did_type: null,
      country_uuid: null,
    },
    did_type: [
      { name: "ANI", value: "ANI" },
      { name: "DNIS", value: "DNIS" },
    ],
    countries: [],
    // dids: [],
    loading: true,
  }),
  computed: {
    ...mapGetters({}),
  },
  created() {
    // this.getDidList();
    this.getCountryList();
  },
  methods: {
    ...mapActions({}),
    transformData(country) {
      return {
        name: country.nice_name,
        value: country.phone_code,
      };
    },
    getCountryList() {
      this.$store.dispatch("getCountryList", {}).then((res) => {
        console.log(res);
        this.countries = res.items.map(this.transformData);
      });
    },
    // getDidList: async function () {
    //   this.loading = true;
    //   let res = await this.$store.dispatch("GetDids", {
    //     // order_by: 'desc',
    //     order_dir: "desc",
    //     has_vendor: false,
    //   });
    //   console.log(",,", res);
    //   if (res.total > 10) {
    //     res = await this.$store.dispatch("GetDids", {
    //       per_page: res.total,
    //       has_vendor: false,
    //     });
    //   }
    //   this.loading = false;
    //   this.dids = res.items.map((did) => {
    //     return { name: did.did, value: did.did };
    //   });
    //   // console.log("dids", this.dids);
    // },
    addDid: async function () {
      const valid = await this.$validator.validate();

      if (!valid) {
        return;
      }
      try {
        const did = {
          did: this.newDid.did,
          vendor_uuid: this.vendorId,
          did_type: this.newDid.did_type,
          country_uuid: this.newDid.country_uuid,
        };
        await this.$store.dispatch("AddDid", { did });

        this.$snotify.success("DID have been added.", {
          timeout: 6000,
        });
        this.$emit("close");
      } catch (err) {
        if (err.errors) {
          this.contactError =
            err.errors[0] && err.errors[0].contact
              ? err.errors[0].contact
              : null;
          setTimeout(() => {
            this.contactError = null;
          }, 6000);
        } else {
          if (err.response) {
            err =
              err.response.data.error && err.response.data.error.message
                ? err.response.data.error.message
                : err.response.data.errors;
          }
          this.$snotify.error(err, { timeout: 6000 });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  font-family: "Helvetica Neue";
  padding: 0 20px;
  min-height: 400px;
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin-bottom: 0;
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        width: 115px;
      }
      .secondary-button {
        height: 40px;
        width: 90px;
        margin-right: 20px;
      }
    }
  }
  .add-container {
    flex-direction: column;
    align-items: center;
    height: fit-content;
    background-color: #ffffff;
    padding-top: 15px;
    .container-title {
      height: 30px;
      width: 432px;
      color: #000000;
      font-size: 16px;
      font-weight: 500;
      line-height: 30px;
      padding: 15px 0 15px 15px;
    }
    .col-wrapper {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-left: 15px;
      margin-top: 20px;
      .col {
        width: 100%;
        margin-right: 5px;
        .input {
          margin-bottom: 20px;
        }
        .pimary-input-title {
          color: #000000;
          font-family: "Helvetica Neue";
          font-size: 12px;
          font-weight: 900;
          letter-spacing: 0.21px;
          line-height: 15px;
          margin-bottom: 5px;
          text-transform: uppercase;
        }
      }
    }
    .loading {
      height: 200px;
    }
  }
}
</style>

